import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderInputComponent } from './components/slider-input.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [SliderInputComponent],
  imports: [CommonModule, FormsModule],
  exports: [SliderInputComponent],
})
export class SliderInputModule {}
